import { useEffect, useRef } from "react";
import { useSession } from "../session/useSession";
import { MarkdownView } from "../components/MarkdownView";
import { ui } from "../components/uiStyles";

/**
 * Paso 5: Dónde comprar el producto elegido.
 *
 * Si llegamos desde Step 4, ya tenemos chosenProduct → auto-dispara.
 * Muestra markdown con tiendas online/presenciales + variantes + alertas.
 * Botón "nueva búsqueda" para empezar de cero.
 */
export function Step5Buy() {
  const {
    formData,
    responses,
    loading,
    error,
    runWhereToBuy,
    resetStep,
    startNewSession,
    goToStep,
  } = useSession();

  const r5 = responses[5];
  const markdown = r5?.markdown;
  const chosen = formData.chosenProduct;

  // Auto-dispara si hay chosenProduct y aún no hay respuesta
  const triggered = useRef(false);
  useEffect(() => {
    if (!markdown && chosen && !loading && !triggered.current) {
      triggered.current = true;
      runWhereToBuy(chosen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chosen]);

  return (
    <div style={ui.card}>
      <h2 style={ui.h2}>Dónde comprar</h2>

      {chosen && (
        <div style={ui.successBadge}>
          ✓ Producto seleccionado: <strong>{chosen}</strong>
        </div>
      )}

      {!chosen && (
        <div style={ui.errorBox}>
          ⚠ No hay producto seleccionado. Vuelve al paso anterior y elige una opción.
        </div>
      )}

      {loading && (
        <p style={{ fontSize: "13px", color: "#888" }}>
          Buscando dónde comprar... (puede tardar más por la búsqueda web)
        </p>
      )}

      {error && <div style={ui.errorBox}>❌ {error}</div>}

      {markdown && (
        <>
          <MarkdownView>{markdown}</MarkdownView>

          <div style={{ display: "flex", gap: "10px", marginTop: "16px", flexWrap: "wrap" }}>
            <button style={ui.secondaryBtn} onClick={() => goToStep(4)}>
              ← Volver a comparación
            </button>
            <button
              style={ui.secondaryBtn}
              disabled={loading}
              onClick={() => runWhereToBuy(chosen, { force: true })}
              title="Ignora el resultado guardado y consulta al modelo de nuevo"
            >
              🔄 Buscar de nuevo
            </button>
            <button
              style={{ ...ui.primaryBtn, background: "#1a4a2e" }}
              onClick={startNewSession}
            >
              🆕 Nueva investigación
            </button>
          </div>
        </>
      )}
    </div>
  );
}
